import React from "react";
import "../css/wipremium.css";
import Phone from "../images/phone01.png";
const PremiumExplained = () => {
  return (
    <div className="main">
      <div className="grid_columns">
        <div className="grid">
          <div className="row">
            <h2 className="title">
              What is <strong>Premium Access?</strong>
            </h2>
            <div className="subtext">
              Purchase of Premium Access will give you access to one or our
              Friends personal <strong>uncensored</strong> social media account.
            </div>
          </div>
          <div className="row">
            <h2 className="title">
              <strong>How</strong> does is work?
            </h2>
            <ol className="list">
              <li className="item">
                <strong>Find</strong> your Username
              </li>
              <li className="item">
                <strong>Join</strong> one of our Friends
              </li>
              <li className="item">
                <strong>Retrieve</strong> their private information
                <small>from AddFriends.com/vip</small>
              </li>
              <li className="item">
                <strong>Add </strong> them as a friend!
                <small>(requests generally accepted with in 60 minutes)</small>
              </li>
            </ol>
          </div>
        </div>
        <div className="grid second">
          <div className="phone">
            <img src={Phone} alt="" />
          </div>
        </div>
      </div>
      <div className="bottom_more">
        More questions?{" "}
        <a href="https://addfriends.com/contact-us">
          Click here to Contact Us!
        </a>
      </div>
    </div>
  );
};

export default PremiumExplained;
